<template>
	<div ref="w">
		<v-data-table
			:value="value"
			:headers="headersWithFilters"
			:items="items"
			:items-per-page="itemsPerPage"
			:hide-default-header="hideDefaultHeader"
			:hide-default-footer="!filterClient"
			:multi-sort="multiSort"
			:disable-sort="disableSort"
			:no-data-text="loading ? 'Загрузка...' : 'Ничего не нашлось'"
			:no-results-text="loading ? 'Загрузка...' : 'Ничего не нашлось'"
			:mobile-breakpoint="0"
			:search="filterClient ? search : null"
			:item-key="itemKey"
			:footer-props="{
				itemsPerPageText: 'Строк на странице',
				itemsPerPageOptions: [10, 25, 50, 100, -1]
			}"
			:show-expand="showExpand"
			:single-expand="singleExpand"
			:show-select="showSelect"
			:single-select="singleSelect"
			:expanded.sync="expanded"
			:loading="loading && loadingFormat == 'top'"
			@change="onChange"
		>
			<template v-slot:top v-if="!hideSearch">
				<template v-if="!chipsInText">
					<v-chip
						v-for="chip in chips"
						:key="chip.name"
						class="ma-1"
						close
						label
						@click="dialog = true"
						@click:close="deleteChip(chip)"
					>
						{{ chip.text }}
					</v-chip>
				</template>
				<div ref="t">
					<v-text-field
						v-model="search"
						v-resize="onResize"
						class="px-3 pb-3"
						hide-details
						single-line
						height="44"
						label="Поиск"
					>
						<template
							v-slot:prepend-inner
						>
							<div
								ref="c"
								v-show="chipsInText"
								class="text-no-wrap"
							>
								<v-chip
									v-for="chip in chips"
									:key="chip.name"
									class="mx-1"
									close
									label
									@click="dialog = true"
									@click:close="deleteChip(chip)"
								>
									{{ chip.text }}
								</v-chip>
							</div>
						</template>
						<template v-slot:append-outer>
							<v-btn
								small
								color="primary"
								class="mt-2"
								@click="openDialog"
							>
								Фильтры
							</v-btn>
							<slot name="search-append-right"></slot>
						</template>
						<template v-slot:append>
							<v-icon
								v-if="search.length"
								@click="search = ''"
								class="mt-2"
							>
								clear
							</v-icon>
						</template>
					</v-text-field>
				</div>
			</template>

			<template v-slot:header.data-table-select>
			</template>

			<template v-slot:progress>
				<v-progress-linear
					indeterminate
					color="secondary"
			    ></v-progress-linear>
			</template>

			<template v-slot:item="{ item }">
				<tr @click="clickRow(item)"
					:class="[
						item.bold ? 'font-weight-medium' : '',
						item.grey ? 'grey--text' : ''
					]"
					:style="rowCursorPointer ? 'cursor: pointer;' : ''"
				>
					<td v-if="showSelect">
						<v-checkbox
							hide-details
							class="mt-0"
							color="secondary"
							:input-value="value"
							@change="select(item)"
							:value="item"
						></v-checkbox>
						<!-- :value="isSelected(item)"
						@change="select(item)" -->
					</td>
					<td v-if="showExpand">
						<!-- <v-hover v-slot:default="{ hover }">
							<v-icon :style="hover ? 'cursor: pointer' : ''">
								{{ isExpanded(item) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
							</v-icon>
						</v-hover> -->
						<v-btn small icon :ripple="false">
							<v-icon>
								{{ isExpanded(item) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
							</v-icon>
						</v-btn>
					</td>
					<td v-for="header in headers"
						:key="header.value"
						:class="[
							'text-' + header.align,
							header.noWrap ? 'text-no-wrap' : ''
						]"
					>
						<template v-if="!!$scopedSlots['item.' + header.value]">
							<slot
								:name="'item.' + header.value"
								:item="item"
							></slot>
						</template>
						<template v-else>
							{{ item[header.value] }}
						</template>
					</td>
				</tr>
			</template>

			<template
				v-slot:expanded-item="{ item }"
				v-if="showExpand"
			>
				<slot
					name="expanded-item"
					:item="item"
				></slot>
			</template>

			<template v-slot:footer v-if="loadingFormat == 'bottom'">
				<v-progress-linear
					v-if="loading"
					indeterminate
					color="secondary"
			    ></v-progress-linear>
				<!-- v-intersect="onIntersectBottom" -->
			</template>
		</v-data-table>
		<v-dialog
			v-model="dialog"
			width="800px"
		>
			<v-card tile>
				<v-card-title class="headline">
					Фильтры
				</v-card-title>
				<v-card-text class="text--primary">
					<v-container>
						<v-row v-for="(f, i) in filters" :key="i">
							<template v-if="f.type == 'select'">
								<v-col cols="12" class="pa-1">
									<a-data-table-autocomplete
										:filter.sync="f"
									></a-data-table-autocomplete>
								</v-col>
							</template>
							<template v-else-if="f.type == 'text'">
								<v-col cols="12" class="pa-1">
									<v-text-field
										v-model="f.value"
										:label="f.text + ' содержит'"
									></v-text-field>
								</v-col>
							</template>
							<template v-else-if="f.type == 'number'">
								<v-col cols="6" class="pa-1">
									<a-number-field
										v-model="f.value.from"
										:label="f.text + ' от'"
										clearable
									></a-number-field>
								</v-col>
								<v-col cols="6" class="pa-1">
									<a-number-field
										v-model="f.value.to"
										:label="f.text + ' до'"
										clearable
									></a-number-field>
								</v-col>
							</template>
							<template v-else-if="f.type == 'month'">
								<v-col cols="6" class="pa-1">
									<v-menu
										v-model="f.menu.from"
										:close-on-content-click="false"
										transition="scale-transition"
										:nudge-right="40"
										offset-y
										max-width="290px"
										min-width="290px"
									>
										<template v-slot:activator="{ on }">
											<v-text-field
												v-model="f.value.from"
												:label="f.text + ' с'"
												prepend-icon="event"
												readonly
												v-on="on"
											></v-text-field>
										</template>
										<v-date-picker
											v-if="f.menu.from"
											v-model="f.value.from"
											locale="ru-RU"
											first-day-of-week="1"
											:show-current="false"
											type="month"
											no-title
											scrollable
											@input="f.menu.from = false"
										></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="6" class="pa-1">
									<v-menu
										v-model="f.menu.to"
										:close-on-content-click="false"
										transition="scale-transition"
										:nudge-right="40"
										offset-y
										max-width="290px"
										min-width="290px"
									>
										<template v-slot:activator="{ on }">
											<v-text-field
												v-model="f.value.to"
												:label="f.text + ' по'"
												prepend-icon="event"
												readonly
												v-on="on"
											></v-text-field>
										</template>
										<v-date-picker
											v-if="f.menu.to"
											v-model="f.value.to"
											locale="ru-RU"
											first-day-of-week="1"
											:show-current="false"
											type="month"
											no-title
											scrollable
											@input="f.menu.to = false"
										></v-date-picker>
									</v-menu>
								</v-col>
							</template>
							<template v-else-if="f.type == 'boolean'">
								<v-col cols="12" class="pa-1">
									<v-select
										v-model="f.value"
										:label="f.text"
										:items="booleanSelectItems"
										clearable
									></v-select>
								</v-col>
							</template>
							<template v-else-if="f.type == 'date'">
								<v-col cols="6" class="pa-1">
									<v-menu
										v-model="f.menu.from"
										:close-on-content-click="false"
										transition="scale-transition"
										:nudge-right="40"
										offset-y
										max-width="290px"
										min-width="290px"
									>
										<template v-slot:activator="{ on }">
											<v-text-field
												v-model="f.value.from"
												:label="f.text + ' с'"
												prepend-icon="event"
												readonly
												clearable
												v-on="on"
											></v-text-field>
										</template>
										<v-date-picker
											v-if="f.menu.from"
											v-model="f.value.from"
											locale="ru-RU"
											first-day-of-week="1"
											:show-current="false"
											no-title
											scrollable
											@input="f.menu.from = false"
										></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="6" class="pa-1">
									<v-menu
										v-model="f.menu.to"
										:close-on-content-click="false"
										transition="scale-transition"
										:nudge-right="40"
										offset-y
										max-width="290px"
										min-width="290px"
									>
										<template v-slot:activator="{ on }">
											<v-text-field
												v-model="f.value.to"
												:label="f.text + ' по'"
												prepend-icon="event"
												readonly
												clearable
												v-on="on"
											></v-text-field>
										</template>
										<v-date-picker
											v-if="f.menu.to"
											v-model="f.value.to"
											locale="ru-RU"
											first-day-of-week="1"
											:show-current="false"
											no-title
											scrollable
											@input="f.menu.to = false"
										></v-date-picker>
									</v-menu>
								</v-col>
							</template>
							<template v-else-if="f.type == 'time'">
								<v-col cols="6" class="pa-1">
									<v-menu
										v-model="f.menu.from"
										:close-on-content-click="false"
										transition="scale-transition"
										:nudge-right="40"
										offset-y
										max-width="290px"
										min-width="290px"
									>
										<template v-slot:activator="{ on }">
											<v-text-field
												v-model="f.value.from"
												:label="f.text + ' с'"
												prepend-icon="access_time"
												readonly
												clearable
												v-on="on"
											></v-text-field>
										</template>
										<v-time-picker
											v-if="f.menu.from"
											v-model="f.value.from"
											format="24hr"
											@click:minute="f.menu.from = false"
										></v-time-picker>
									</v-menu>
								</v-col>
								<v-col cols="6" class="pa-1">
									<v-menu
										v-model="f.menu.to"
										:close-on-content-click="false"
										transition="scale-transition"
										:nudge-right="40"
										offset-y
										max-width="290px"
										min-width="290px"
									>
										<template v-slot:activator="{ on }">
											<v-text-field
												v-model="f.value.to"
												:label="f.text + ' по'"
												prepend-icon="access_time"
												readonly
												clearable
												v-on="on"
											></v-text-field>
										</template>
										<v-time-picker
											v-if="f.menu.to"
											v-model="f.value.to"
											format="24hr"
											@click:minute="f.menu.to = false"
										></v-time-picker>
									</v-menu>
								</v-col>
							</template>
							<template v-else-if="f.type == 'dateTime'">
								<v-col cols="6" class="pa-1">
									<v-menu
										v-model="f.menu.from"
										:close-on-content-click="false"
										transition="scale-transition"
										:nudge-right="40"
										offset-y
										max-width="580px"
										min-width="580px"
									>
										<template v-slot:activator="{ on }">
											<v-text-field
												:value="dateTimeValue(f.value.from)"
												:label="f.text + ' с'"
												prepend-icon="access_time"
												readonly
												clearable
												v-on="on"
											></v-text-field>
										</template>
										<v-card>
											<v-row no-gutters>
												<v-col cols="6">
													<v-date-picker
														v-if="f.menu.from"
														v-model="f.value.from.date"
														:show-current="false"
														locale="ru-RU"
														first-day-of-week="1"
														no-title
														class="elevation-0"
													>
													</v-date-picker>
												</v-col>
												<v-col cols="6">
													<v-time-picker
														v-if="f.menu.from"
														v-model="f.value.from.time"
														format="24hr"
														no-title
														class="elevation-0"
													>
														<div class="flex-grow-1"></div>
														<v-btn text @click="dateTimeMenuFromCancel(f)">Отмена</v-btn>
														<v-btn text @click="f.menu.from = false">Ок</v-btn>
													</v-time-picker>
												</v-col>
											</v-row>
										</v-card>
									</v-menu>
								</v-col>
								<v-col cols="6" class="pa-1">
									<v-menu
										v-model="f.menu.to"
										:close-on-content-click="false"
										transition="scale-transition"
										:nudge-right="40"
										offset-y
										max-width="580px"
										min-width="580px"
									>
										<template v-slot:activator="{ on }">
											<v-text-field
												:value="dateTimeValue(f.value.to)"
												:label="f.text + ' по'"
												prepend-icon="access_time"
												readonly
												clearable
												v-on="on"
											></v-text-field>
										</template>
										<v-card>
											<v-date-picker
												v-if="f.menu.to"
												v-model="f.value.to.date"
												:show-current="false"
												locale="ru-RU"
												first-day-of-week="1"
												no-title
												class="elevation-0"
											></v-date-picker>
											<v-time-picker
												v-if="f.menu.to"
												v-model="f.value.to.time"
												format="24hr"
												no-title
												class="elevation-0"
											>
												<div class="flex-grow-1"></div>
												<v-btn text @click="dateTimeMenuToCancel(f)">Отмена</v-btn>
												<v-btn text @click="f.menu.to = false">Ок</v-btn>
											</v-time-picker>
										</v-card>
									</v-menu>
								</v-col>
							</template>
						</v-row>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-btn text @click="applyFilters">Готово</v-btn>
					<v-btn text @click="clearFilters">Сбросить</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import _ from 'lodash'
import aNumberField from './ANumberField.vue'
import aDataTableAutocomplete from './ADataTableAutocomplete.vue'
import { api } from '../../lib/api'
import { toStr, toNum } from '../../js/common.js'

export default {
	components: {
		aNumberField,
		aDataTableAutocomplete
	},
	props: {
		apiPath: String,
		apiParameters: {
			type: Object,
		},
		disableSort: {
			type: Boolean,
			default: false
		},
		headers: Array,
		hideDefaultHeader: {
			type: Boolean,
			default: false
		},
		hideDefaultFooter: {
			type: Boolean,
			default: true
		},
		hideSearch: {
			type: Boolean,
			default: false
		},
		itemsPerPage: {
			type: Number,
			default: -1
		},
		initial: {
			type: Object,
			default: () => {}
		},
		itemKey: {
			type: String,
			default: 'id'
		},
		filterClient: {
			// filterClient должен применяться только таблица до 256 строк
			// они загружаются с сервера целиком, поиск и фильтры работают на клиенте
			//
			// filterServer должен применяться для таблиц от 256 строк
			// они загружаются по {{ loadSize }} строк
			// фильтруются на стороне сервера
			// подгружаются по мере прокрутки
			type: Boolean,
			default: false
		},
		loadingFormat: {
			type: String,
			default: 'bottom'
		},
		multiSort: {
			type: Boolean,
			default: false
		},
		rowCursorPointer: {
			type: Boolean,
			default: false
		},
		showExpand: {
			type: Boolean,
			default: false
		},
		singleExpand: {
			type: Boolean,
			default: false
		},
		showSelect: {
			type: Boolean,
			default: false
		},
		singleSelect: {
			type: Boolean,
			default: false
		},
		value: {
			type: Array,
			default: () => []
		},
	},
	data: () => ({
		booleanSelectItems: [
			{
				text: 'Да',
				value: 1
			},
			{
				text: 'Нет',
				value: 0
			}
		],
		chips: [],
		debug: false,
		dialog: false,
		headersWithFilters: [],
		expanded: [],
		items: [],
		filters: [],
		filtersChanged: true,
		loadSize: 50,
		loaded: false,
		loading: false,
		search: '',
		textFieldWidth: 0,
	}),
	computed: {
		chipsInText() {
			let chipsLength = this.chips.reduce((acc, cur) => acc + cur.text.length, 0)

			return chipsLength * 10 + 500 < this.textFieldWidth
		},
		filtersAndSearch() {
			let f = this.filters.filter(f => {
				if (f.type == 'number') {
					if (f.value.from || f.value.to) return true
					else return false
				}
				else if (f.type == 'select') {
					if (f.value.length) return true
					else return false
				}
				else if (f.type == 'text') {
					if (f.value.length) return true
					else return false
				}
				else if (f.type == 'date' || f.type == 'month' || f.type == 'time') {
					if (f.value.from || f.value.to) return true
					else return false
				}
				else if (f.type == 'boolean') {
					if (f.value !== '' && f.value !== undefined) return true
					else return false
				}
				else if (f.type == 'dateTime') {
					let from = this.dateTimeValue(f.value.from)
					let to = this.dateTimeValue(f.value.to)

					if (from || to) return true
					else return false
				}
			})

			if (this.search.length) {
				f.push({
					type: 'search',
					value: this.search
				})
			}

			return f
		},
	},
	watch: {
		apiPath() {
			if (this.debug) console.log('watcher apiPath')
			this.search = ''
			this.clearFilters()
			this.clearAndLoad()
		},
		apiParameters: {
			handler: function(newVal, oldVal) {
				if (this.debug) console.log('watcher apiParameters')
				var changes = false
				for (let p in newVal) {
					if (newVal[p] != oldVal[p]) {
						changes = true
					}
				}
				if (changes) {
					this.search = ''
					this.clearFilters()
					this.clearAndLoad()
				}
			},
			deep: false
		},
		headers() {
			this.addFiltersToHeaders()
		},
		filters: {
			handler: function () {
				this.filtersChanged = true
			},
			deep: true
		},
		search() {
			if (!this.filterClient) {
				this.debouncedSearch()
			}
		},
	},
	methods: {
		addFiltersToHeaders() {
			this.headersWithFilters = this.headers.map(h => {

				if (h.filterable) {
					var f = this.filters.find(f => f.name == h.value)

					if (f) {
						var e = _.cloneDeep(f)
						var filterColumn

						if (e.type == 'number') {
							h.filter = function(val) {
								let from = toNum(e.value.from)
								let to = toNum(e.value.to)

								if (e.value.from && e.value.to) {
									return +val >= from && +val <= to
								}
								else if (e.value.from) {
									return +val >= from
								}
								else if (e.value.to) {
									return +val <= to
								}
								else {
									return true
								}
							}
						}
						else if (e.type == 'month') {
							// нужно проверить работу этого блока
							h.filter = function(val, search, item) {
								let from = e.value.from ? new Date(e.value.from) : ''
								let to = e.value.to ? new Date(e.value.to) : ''

								let date = new Date(item.year + ' ' + item.month)

								if (from && to) {
									return date >= from && date <= to
								}
								else if (from) {
									return date >= from
								}
								else if (to) {
									return date <= to
								}
								else {
									return true
								}
							}
						}
						else if (e.type == 'boolean') {
							h.filter = function(val) {
								return val == e.value
							}
						}
						else if (e.type == 'date' || e.type == 'time') {
							filterColumn = h.filterColumn
							h.filter = function(val, search, item) {
								let from = e.value.from ? new Date(e.value.from) : ''
								let to = e.value.to ? new Date(e.value.to) : ''

								let time = filterColumn ? new Date(+item[filterColumn] * 1000) : new Date(+val * 1000)

								if (from && to) {
									return time >= from && time <= to
								}
								else if (from) {
									return time >= from
								}
								else if (to) {
									return time <= to
								}
								else {
									return true
								}
							}
						}
						else if (e.type == 'dateTime') {
							filterColumn = h.filterColumn
							var dateTimeValue = this.dateTimeValue

							h.filter = function(val, search, item) {
								let from = dateTimeValue(e.value.from)
								from = from ? new Date(from) : ''
								let to = dateTimeValue(e.value.to)
								to = to ? new Date(to) : ''

								let time = filterColumn ? new Date(+item[filterColumn] * 1000) : new Date(+val * 1000)

								if (from && to) {
									return time >= from && time <= to
								}
								else if (from) {
									return time >= from
								}
								else if (to) {
									return time <= to
								}
								else {
									return true
								}
							}
						}
						else if (e.type == 'select') {
							h.filter = function(val) {
								return e.value.indexOf(val) >= 0
							}
						}
						else {
							h.filter = function(val) {
								return val.includes(e.value)
							}
						}
					}
					else {
						h.filter = undefined
					}
				}

				return h
			})
		},
		applyFilters() {
			if (this.debug) console.log('applyFilters')

			if (this.filtersChanged) {
				this.setChips()
				this.filtersChanged = false

				if (!this.filterClient) {
					this.clearAndLoad()
				}
				else {
					this.addFiltersToHeaders()
				}
			}
			this.dialog = false
		},
		clearAndLoad() {
			if (this.debug) console.log('clearAndLoad')

			this.loaded = false
			this.load(true)
		},
		clearFilter(f) {
			if (this.debug) console.log('clearFilter')
			if (f.type == 'select') {
				f.value = []
			}
			else if (f.type == 'number' || f.type == 'date' || f.type == 'time' || f.type == 'month') {
				f.value = {
					from: '',
					to: ''
				}
			}
			else if (f.type == 'boolean' || f.type == 'text') {
				f.value = ''
			}
			else if (f.type == 'dateTime') {
				f.value = {
					from: {
						date: '',
						time: '',
					},
					to: {
						date: '',
						time: '',
					}
				}
			}
		},
		clearFilters() {
			if (this.debug) console.log('clearFilters')

			this.filters.forEach(f => this.clearFilter(f))
			this.chips = []
			this.filtersChanged = false

			if (!this.filterClient) {
				this.clearAndLoad()
			}
			else {
				this.addFiltersToHeaders()
			}

			this.dialog = false
		},
		clickRow(row) {
			if (this.showExpand) {
				let i = this.expanded.indexOf(row)
				if (i >= 0) {
					this.expanded.splice(i, 1)
				}
				else {
					if (this.singleExpand) {
						this.expanded = []
					}
					this.expanded.push(row)
				}
			}
			this.$emit('click:row', row)
		},
		dateTimeMenuFromCancel(f) {
			f.menu.from = false
			f.value.from.date = ''
			f.value.from.time = ''
		},
		dateTimeMenuToCancel(f) {
			f.menu.from = false
			f.value.to.date = ''
			f.value.to.time = ''
		},
		dateTimeValue(val) {
			if (val.date.length || val.time.length) {
				return val.date + ' ' + val.time
			}
			else return ''
		},
		deleteChip(chip) {
			if (this.debug) console.log('deleteChip')

			this.chips.splice(this.chips.indexOf(chip), 1)
			let f = this.filters.find(f => f.name == chip.name)
			this.clearFilter(f)
			this.filtersChanged = false

			if (!this.filterClient) {
				this.clearAndLoad()
			}
			else {
				this.addFiltersToHeaders()
			}
		},
		distinct(value) {
			return this.items.map(item => item[value]).filter(
				(value, index, self) => {
					// console.log(value, self.indexOf(value), index)
					return self.indexOf(value) === index
				}
			)
		},
		getSelectItems(f) {
			if (this.debug) console.log('api call get_select_items')

			let p = _.cloneDeep(this.apiParameters)

			api.post(this.apiPath, Object.assign({}, p, {
				getSelectItems: true,
				column: f.name
			}))
			.then(response => {

				f.selectItems = response.data.items

			}, error => {})
		},
		isExpanded(row) {
			return this.expanded.indexOf(row) >= 0
		},
		isSelected(item) {
			return this.value.indexOf(item) >= 0
		},
		load(clear) {
			if (this.debug) console.log('load')
			if (clear === undefined) clear = false

			// clear означает, что после ответа сервера таблица будет очищена, и результат вставлен в пустую таблицу

			if (!this.loaded && !this.loading) {
				this.loading = true

				if (this.debug) console.log('api call load')

				let p = _.cloneDeep(this.apiParameters)

				api.post(this.apiPath, Object.assign({}, p, {
					offset: clear ? 0 : this.items.length,
					limit: this.filterClient ? 0 : this.loadSize,
					filters: this.filtersAndSearch
				}))
				.then(response => {
					if (this.debug) {
						let d = response.data.data
						if (d.length) console.log('load Response', d[0].id, d[d.length - 1].id)
					}

					if (clear) {
						this.items = []
						this.expanded = []
					}

					response.data.data.forEach(r => this.items.push(r))
					this.loaded = response.data.loaded
					this.loading = false

					this.$emit('load')

				}, error => {
					this.loading = false
				})
			}
		},
		onChange(e) {
			this.$emit('change', e)
		},
		onResize() {
			this.textFieldWidth = this.$refs.t.clientWidth
		},
		openDialog() {
			this.dialog = true
			this.setFilters()
		},
		scrolled() {
			if (this.debug) console.log('scrolled')
			if (!this.loaded) {
				this.load()
			}
		},
		select(item) {
			let i = this.value.indexOf(item)

			if (i >= 0) {
				this.$emit('input', this.value.filter((row, j) => j != i))
			}
			else {
				if (this.singleSelect) {
					this.$emit('input', [])
				}
				this.$emit('input', this.value.concat([item]))
			}
		},
		setChips() {
			this.chips = []

			this.filters.forEach(f => {
				if (f.type == 'number') {
					if (f.value.from || f.value.to) {
						let s = f.text + ':'
						if (f.value.from) s = s + ' от ' + toStr(f.value.from, 0)
						if (f.value.to) s = s + ' до ' + toStr(f.value.to, 0)
						this.chips.push({
							text: s,
							name: f.name
						})
					}
				}
				else if (f.type == 'select') {
					if (f.value.length) {
						let s = f.text + ': '

						if (f.value.length > 3) {
							s += 'Выбрано ' + f.value.length
						}
						else if (typeof f.selectItems[0] == 'object') {
							s += f.selectItems
								.filter(i => f.value.includes(i.value))
								.map(i => i.text)
								.join(', ')
						}
						else {
							s += f.value.join(', ')
						}

						this.chips.push({
							text: s,
							name: f.name
						})
					}
				}
				else if (f.type == 'text') {
					if (f.value.length) {
						let s = f.text + ': ' + f.value
						this.chips.push({
							text: s,
							name: f.name
						})
					}
				}
				else if (f.type == 'date' || f.type == 'month' || f.type == 'time') {
					if (f.value.from || f.value.to) {
						let s = f.text + ':'
						if (f.value.from) s = s + ' с ' + f.value.from
						if (f.value.to) s = s + ' по ' + f.value.to
						this.chips.push({
							text: s,
							name: f.name
						})
					}
				}
				else if (f.type == 'boolean') {
					if (f.value !== '') {
						let s = f.text + ': ' + (f.value ? 'Да' : 'Нет')
						this.chips.push({
							text: s,
							name: f.name
						})
					}
				}
				else if (f.type == 'dateTime') {
					let from = this.dateTimeValue(f.value.from)
					let to = this.dateTimeValue(f.value.to)

					if (from || to) {
						let s = f.text + ':'

						if (from) s = s + ' c ' + from
						if (to) s = s + ' по ' + to
						this.chips.push({
							text: s,
							name: f.name
						})
					}
				}
			})
		},
		setFilters() {
			if (this.hideSearch) return
			if (this.filters.length) return

			this.headers.forEach(header => {
				if (header.filterable) {
					if (header.filterType == 'number') {
						this.filters.push({
							name: header.value,
							type: 'number',
							text: header.text,
							value: {
								from: '',
								to: ''
							}
						})
					}
					else if (header.filterType == 'month') {
						this.filters.push({
							name: header.value,
							type: 'month',
							menu: {
								from: false,
								to: false
							},
							text: header.text,
							value: {
								from: '',
								to: ''
							}
						})
					}
					else if (header.filterType == 'boolean') {
						this.filters.push({
							name: header.value,
							type: 'boolean',
							text: header.text,
							value: ''
						})
					}
					else if (header.filterType == 'date') {
						this.filters.push({
							name: header.value,
							type: 'date',
							menu: {
								from: false,
								to: false
							},
							text: header.text,
							value: {
								from: '',
								to: ''
							}
						})
					}
					else if (header.filterType == 'time') {
						this.filters.push({
							name: header.value,
							type: 'time',
							menu: {
								from: false,
								to: false
							},
							text: header.text,
							value: {
								from: '',
								to: ''
							}
						})
					}
					else if (header.filterType == 'dateTime') {
						this.filters.push({
							name: header.value,
							type: 'dateTime',
							menu: {
								from: false,
								to: false
							},
							text: header.text,
							value: {
								from: {
									date: '',
									time: '',
								},
								to: {
									date: '',
									time: '',
								}
							}
						})
					}
					else if (header.filterType == 'select') {
						var items = []

						let f = {
							search: null,
							name: header.value,
							type: 'select',
							text: header.text,
							value: []
						}

						if (this.filterClient) {
							f.selectItems = this.distinct(f.name)
						}
						else {
							this.getSelectItems(f)
						}

						this.filters.push(f)
					}
					// по умолчанию - text
					else {
						this.filters.push({
							name: header.value,
							type: 'text',
							text: header.text,
							value: ''
						})
					}
				}
			})
		},
	},
	created() {
		this.throttledScrolled = _.throttle(this.scrolled, 1000)
		this.debouncedSearch = _.debounce(this.clearAndLoad, 750)

		this.headersWithFilters = this.headers

		if (this.initial !== undefined
			&& this.initial.search !== undefined
			&& this.initial.filters !== undefined
		) {
			this.search = this.initial.search
			this.filters = this.initial.filters
			this.setChips()
		}

		this.load()
	},
	mounted() {
		if (!this.hideSearch) {
			this.onResize()
		}
		if (!this.filterClient) {
			window.onscroll = () => {
				let scrolled = document.documentElement.scrollTop + window.innerHeight > document.documentElement.offsetHeight - 500
				if (scrolled) this.throttledScrolled()
			}
		}
	},
}
</script>

<style scoped>

</style>
